/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "",
    // Relative to /src/views
    view: "Analytics",
    meta: { requiresAuth: true },
  },
  {
    path: "/looks",
    name: "Looks",
    view: "Looks",
    meta: { requiresAuth: true },
  },
  {
    path: "/messages",
    name: "Messages",
    view: "Messages",
    meta: { requiresAuth: true },
  },
  {
    path: "/Userinfos",
    name: "Users informations",
    view: "Userinfos",
    meta: { requiresAuth: true },
  },
  {
    path: "/selectItems",
    name: "SelectItems",
    view: "SelectItems",
    meta: { requiresAuth: true },
  },
  {
    path: "/I18n",
    name: "Store i18n",
    view: "I18n",
    meta: { requiresAuth: true },
  },
  {
    path: "/Admin_i18n",
    name: "Admin i18n",
    view: "Admin_i18n",
    meta: { requiresAuth: true },
  },
  {
    path: "/EmailApiDetails",
    name: "Email Details",
    view: "EmailApiDetails",
    meta: { requiresAuth: true },
  },
  {
    path: "/VisualSearch",
    name: "VisualSearch",
    view: "VisualSearch",
    meta: { requiresAuth: true },
  },
  {
    path: "/Shopify",
    name: "Shopify",
    view: "Shopify",
    meta: { requiresAuth: true },
  },
  {
    path: "/LlmConfig",
    name: "LlmConfig",
    view: "LlmConfig",
    meta: { requiresAuth: true },
  },
  {
    path: "/LlmPlayground",
    name: "LlmPlayground",
    view: "LlmPlayground",
    meta: { requiresAuth: true },
  },
  {
    path: "/AuthOptionEmailList",
    name: "Email List",
    view: "AuthOptionEmailList",
    meta: { requiresAuth: true },
  },
  {
    path: "/Settings",
    name: "Settings",
    view: "Settings",
    meta: { requiresAuth: true },
  },
  {
    path: "/ShopifyApp",
    name: "ShopifyApp",
    view: "ShopifyApp",
  },
  {
    path: "/404",
    name: "404",
    view: "404",
  },
  {
    path: "/ShopifyAppHome",
    name: "ShopifyAppHome",
    view: "ShopifyAppHome",
  },
  {
    path: "/chat",
    name: "Chat",
    view: "Chat",
  },
  {
    path: "/login",
    name: "Login",
    view: "Login",
  },
  {
    path: "/user-profile",
    name: "User Profile",
    view: "UserProfile",
  },
  {
    path: "/table-list",
    name: "Table List",
    view: "TableList",
  },
  {
    path: "/typography",
    view: "Typography",
  },
  {
    path: "/icons",
    view: "Icons",
  },
  {
    path: "/maps",
    view: "Maps",
  },
  {
    path: "/notifications",
    view: "Notifications",
  },
  {
    path: "/upgrade",
    name: "Upgrade to PRO",
    view: "Upgrade",
  },
];
